import { 
  createUseStyles
} from 'react-jss';

const useStyles = createUseStyles({
  container: {
    backgroundColor:'#141414',
    justifyContent: 'center',
    flexDirection:'column',
    position: 'relative',
    alignItems: 'start',
    display: 'flex',
    height: '100vh',
    zIndex:1,
    },
    img: {
      position: 'absolute',
      objectFit: 'cover',
      padding: '0 20%',
      height: '100%',
      zIndex: 1,
      left: 0,
      top: 0,
      '@media (max-width: 1400px)': {
        objectFit: 'contain',
        height: '100vh',
        width: '100%',
        padding: 0,
      },
    },
  homeFooter: {
    fontFamily: 'Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '0 10% 40px',
    color: 'white',
    zIndex: 2,
    '@media (max-width: 1400px)': {
      padding: '0 50px 40px',
    },
    '@media (max-width: 991px)': {
      padding: '0 30px 40px',
      gap: '4px',
    },
  },
  titleRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    fontSize: 28,
    fontWeight: 400,
    '@media (max-width: 991px)': {
      fontSize: 22,
    },
  },
  row:{
    display:'flex',
    padding:5,
    '@media (max-width: 991px)': {
      flexDirection:'column',
    },
  },
green: {
    color: '#4affa4',
    fontWeight: 700,
  },
  subtitleRow: {
    fontSize: 18,
    fontWeight: 300,
    color: '#a3a3a3',
    letterSpacing: '0.5px',
    '@media (max-width: 991px)': {
      fontSize: 15,
    },
  },
});

export default useStyles;
